import React from 'react';

import PropTypes from 'prop-types';
import { Header, Segment } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import { SeoMetadataFieldsProvider } from './SeoMetadata.context';
import { SeoTitle, SeoDescription, SeoOgTitle, SeoOgDescription, SeoOgImage } from './components';
import { ChildrenPropType } from '../../../../../libs/proptypes';

import './SeoMetadataFields.scss';

const propTypes = {
  children: ChildrenPropType.isRequired,
  onChange: PropTypes.func.isRequired,
  pageType: PropTypes.string.isRequired,
  header: PropTypes.string,
};

const defaultProps = {
  header: 'SEO Information',
};

export default function SeoMetadataFields({ children, onChange: onChangeProp, pageType, header }) {
  function onChange(e, target) {
    if (onChangeProp) {
      onChangeProp(e, target);
    }
  }

  const context = { onChange, pageType };

  return (
    <SeoMetadataFieldsProvider value={context}>
      <Segment className="seo-metadata-fields">
        {!_isEmpty(header) && <Header>{header}</Header>}
        <div className="content">{children}</div>
      </Segment>
    </SeoMetadataFieldsProvider>
  );
}

SeoMetadataFields.propTypes = propTypes;
SeoMetadataFields.defaultProps = defaultProps;

SeoMetadataFields.SeoTitle = SeoTitle;
SeoMetadataFields.SeoDescription = SeoDescription;
SeoMetadataFields.SeoOgTitle = SeoOgTitle;
SeoMetadataFields.SeoOgDescription = SeoOgDescription;
SeoMetadataFields.SeoOgImage = SeoOgImage;
